require("angular-debounce/dist/angular-debounce.min.js");
export default 'rt.debounce'